module.exports = __webpack_public_path__ + "img/fish3.cd94cb27.png";